import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Button, Card, Form, Image, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { setItem, getItem, clearItem } from '../../config/localStorage';
import { useNavigate } from 'react-router-dom';
import downloadTextIcon from '../../assets/image/Group.png'
import downloadIcon from '../../assets/image/Vector.png'
import UploadPdf from '../../component/uploadpdftemplate/UploadPdf';

function CreateResume() {

  const chossenResumeBuildType = getItem('resumeBuildType');
  const [choosenBuilderType, setChoosenBuilderType] = useState(chossenResumeBuildType ?? 'new-resume');
  const [disabledBtn, setDisabledBtn] = useState(false); // for hide use true or show use false 
  const navigate = useNavigate();
  const checkDataForContinueEditing = JSON.parse(getItem('profileData'));
  const [reuseToken, setReuseToken] = useState('');
  const [reusePythonToken, setPythonReuseToken] = useState('');
  const [reuseResumeBuildType, setReuseResumeBuildType] = useState('');

  /* show modal start */
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  /* show modal end*/

  /* show modal start */
  const [modalPdfShow, setModalPdfShow] = useState(false);
  /* show modal end*/

  const [showNext, setShowNext] = useState(false);

  useEffect(() => {
    setReuseToken(getItem('token'));
    setPythonReuseToken(getItem('authToken'))
    setReuseResumeBuildType(choosenBuilderType);
  }, [reuseToken, reusePythonToken, reuseResumeBuildType, choosenBuilderType])

  useEffect(() => {
    if (checkDataForContinueEditing !== null) {
      setDisabledBtn(false);
    }
  }, [])

  const onOptionChange = (e) => {
    setChoosenBuilderType(e.target.value);
    setShowNext(true);
  }

  setItem('resumeBuildType', choosenBuilderType);

  const MoveProfielPage = (item) => {
    if (item === 'with-new-resume') {
      clearItem();
      setItem('token', reuseToken);
      setItem('authToken', reusePythonToken);
      setItem('resumeBuildType', reuseResumeBuildType);
    }
    navigate('/profile', { state: { profilePaage: true } });
  }


  return (
    <>
      <section className='main-section padding-top-bottom create-resume'>
        <Container>
          <Row>
            <Col lg={12} sm={12}>
              <Form>
                <Card className='resume-card-option shadow border-0'>
                  <Card.Body>
                    <Card.Title>How do you want to build your resume?</Card.Title>
                    <div className='build-your-resume-main'>

                      <div className="build-your-resume-outer">
                        <input type="radio"
                          id="new-resume"
                          name="choosen-builder-type"
                          className="hidden"
                          value="new-resume"
                          checked={choosenBuilderType === "new-resume"}
                          onChange={onOptionChange}
                        />
                        <label htmlFor="new-resume" className={`option-one ${choosenBuilderType === "new-resume" ? 'active' : ''}`}>
                          <Image src={downloadTextIcon} alt="img" className='image-part download-text-icon' />
                          <div className="mb-2 heading-part">Create a new resume</div>
                          <div className="mb-2 text-part">We will help you create a resume step-by-step</div>
                        </label>
                      </div>

                      <div className="build-your-resume-outer position-relative">
                        {/* <div className='comingSoon'> Coming Soon </div>  remove line once upload pdf functionality will done */}
                        {/* remove below comment once functionality will start */}
                        <input type="radio"
                          id="continue-resume"
                          name="choosen-builder-type"
                          value="continue-resume"
                          className='hidden'
                          checked={choosenBuilderType === "continue-resume"}
                          onChange={onOptionChange}
                        />
                        <label htmlFor="continue-resume" className={`option-two ${choosenBuilderType === "continue-resume" ? 'active' : ''}`}>
                          <Image src={downloadIcon} alt="img" className='image-part download-icon' />
                          <div className="mb-2 heading-part">I already have a resume</div>
                          <div className="mb-2 text-part">We'll re-format it and fill in your information <br /> so you don't have to.</div>
                        </label>
                      </div>

                    </div>

                    <Col className='next-prev-btn-section col-md-12'>
                      <Link to='/'><Button className='my-previous-btn' >Back</Button></Link>
                      {
                        choosenBuilderType === 'new-resume' ?
                          <Button className='my-next-btn button-green' onClick={handleShow}>Next</Button>
                          :
                          <Button className='my-next-btn button-green' onClick={() => setModalPdfShow(true)}>Next</Button>

                      }
                    </Col>

                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>

      {/* modal section start here  */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show} onHide={handleClose}
        className='continue-model-section'
        backdrop='static'
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h4>Create new resume</h4>
          <p>By selecting Create New Resume, your content will be<br /> permanently deleted.</p>
          <div className='create-continue-section text-center'>
            <Button size="lg" className='float-start create-new-resume-btn' onClick={(e) => MoveProfielPage('with-new-resume')}>Create new resume</Button>
            <Button size="lg" className='float-end continue-editing-btn button-green' disabled={disabledBtn} onClick={(e) => MoveProfielPage('with-continue-editing')} >Continue editing</Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* modal section end here  */}

      <UploadPdf
        show={modalPdfShow}
        onHide={() => setModalPdfShow(false)}
      />

    </>
  )
}

export default CreateResume
